import {
  CheckCircleOutlined,
  DownOutlined,
  ExclamationCircleTwoTone,
  LeftOutlined,
  MoreOutlined,
  UpOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import React from 'react';

const iconMap = {
  'arrow-left': LeftOutlined,
  warning: WarningOutlined,
  'check-circle': CheckCircleOutlined,
  'exclamation-circle': ExclamationCircleTwoTone,
  ellipsis: MoreOutlined,
  up: UpOutlined,
  down: DownOutlined,
};

type IconProps = Omit<React.ComponentProps<typeof LeftOutlined>, 'type'> & {
  type: keyof typeof iconMap;
  theme?: string;
};

const Icon = ({ type, theme: _theme, ...props }: IconProps) => {
  const IconComponent = iconMap[type];

  if (!IconComponent) {
    if (import.meta.env.DEV) {
      throw new Error(`Unsupported Ant Design icon type: ${type}`);
    }
    return null;
  }

  return <IconComponent {...props} />;
};

export default Icon;
